import React, { useEffect } from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { usePermissions } from 'components/providers/PermissionProvider'
import {
  myParkingLotPermission,
  myParkingLotParkingLotPermission,
  myParkingLotPaymentsPermission,
  myParkingLotAnalyticsPermission,
  myParkingLotCustomerNotificationExclusionsPermission,
} from 'utils'
import { ROUTE } from 'constants/Routes'
import ParkingLot from 'components/views/parking-lot/ParkingLot'
import ParkingPayments from 'ParkingPayments/ParkingPayments'
import Analytics from 'components/views/Analytics'
import CustomerNotificationExclusions from 'CustomerNotificationExclusions/CustomerNotificationExclusions'

export default withRouter(({ history }) => {
  const permissions = usePermissions()

  const hasParkingLotPermission = myParkingLotParkingLotPermission(permissions),
    hasPaymentsPermission = myParkingLotPaymentsPermission(permissions),
    hasAnalyticsPermission = myParkingLotAnalyticsPermission(permissions),
    hasCustomerNotificationExclusionsPermission = myParkingLotCustomerNotificationExclusionsPermission(permissions)

  useEffect(() => {
    if (permissions.length) {
      if (!myParkingLotPermission(permissions)) {
        history.push(ROUTE.SUBSCRIPTIONS.HOME)
      }
    }
  }, [permissions])

  const NAV = [
    hasParkingLotPermission && {
      uri: ROUTE.MY_PARKING_LOT.PARKING_LOT,
    },
    hasPaymentsPermission && {
      uri: ROUTE.MY_PARKING_LOT.PAYMENTS,
    },
    hasAnalyticsPermission && {
      uri: ROUTE.MY_PARKING_LOT.ANALYTICS,
    },
    hasCustomerNotificationExclusionsPermission && {
      uri: ROUTE.MY_PARKING_LOT.CUSTOMER_NOTIFICATION_EXCLUSIONS,
    },
  ].filter(el => el)

  if (history.location.pathname == ROUTE.MY_PARKING_LOT.MAIN && NAV.length && NAV[0]) {
    return <Redirect to={NAV[0].uri} />
  }

  return (
    <Switch>
      {hasParkingLotPermission && (
        <Route path={ROUTE.MY_PARKING_LOT.PARKING_LOT}>
          <ParkingLot />
        </Route>
      )}
      {hasPaymentsPermission && (
        <Route path={ROUTE.MY_PARKING_LOT.PAYMENTS}>
          <ParkingPayments />
        </Route>
      )}
      {hasAnalyticsPermission && (
        <Route path={ROUTE.MY_PARKING_LOT.ANALYTICS}>
          <Analytics />
        </Route>
      )}
      {hasCustomerNotificationExclusionsPermission && (
        <Route path={ROUTE.MY_PARKING_LOT.CUSTOMER_NOTIFICATION_EXCLUSIONS}>
          <CustomerNotificationExclusions />
        </Route>
      )}
    </Switch>
  )
})
